import { Injectable, signal } from "@angular/core";


@Injectable({
    providedIn: 'root'
})
export class ProfileDialogService {
    showSettings = signal(false);

    toggleSettings() {
        this.showSettings.update(value => !value);
    }

    getShowSettings() {
        return this.showSettings;
    }
}